import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { queryKeys } from '../constants';

export function useBookingCount() {
  const enabled = useAppSelector(({ userReducer }) => userReducer?.isPermissions?.PERMISSION_REALTOR_BOOKING);

  const { data, ...arg } = useQuery<{ count: number }>(
    [queryKeys.BOOKING_COUNT],
    async () => {
      const { data } = await $api.get('/v1/realtor-booking/count');

      return { count: data?.data?.count || 0 };
    },
    {
      enabled
    }
  );

  return { ...data, ...arg };
}
